module.exports = __webpack_public_path__ + "img/desktop@3x.6ca1f4f3.png";